// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LogoBabaev_wrapper__1EVJU","link":"LogoBabaev_link__2J3Cd","logo":"LogoBabaev_logo__3rMeJ"};